import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nProvider } from '@rehub/i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { captureAttribution } from './lib/attribution';

captureAttribution();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <App />
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>
);